export const destinations = {
    title: "Destinations",
    sortName: "Nom",
    noResults: "Aucun résultat",
    tryDifferentSearch: "Essayez une recherche différente"
};
